import { Box, Divider, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useLocation, useParams } from "react-router-dom";
import { IInfoColumns, WSInfocard } from "../../../Components/View/WSInfocard";
import { callAPI, formatLabel, Method } from "../../../commonFunctions/CommonFunctions";
import { PaymentVoucherList } from "./PaymentVoucherList";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import WSWovenImageList from "../../../Components/ImageList/ImageList";

export const ViewSurveyorTaskDetailsByLead: React.FC<any> = React.memo((props) => {
  const params = useParams();
  const [surveyData, setSureveyData] = useState<any>();
  const location = useLocation();
  const { row } = location.state || {};
  const { id } = params;

  useEffect(() => {
    async function getSurveyData() {
      const response: any = await callAPI('SiteSurvey/lead', Method.GET, null, id)

      console.log('response is ',response);
      
      if (response) {
        setSureveyData(response)
      }

    }
    getSurveyData();
  }, [id])

  const columns: IInfoColumns[] = [
    {
      fieldName: 'surveyorName',
      label: "Name",
      type: 'none',
      style: { fontSize: '0.875rem' }
    },
    {
      fieldName: 'phoneNumber',
      label: "Phone",
      type: 'none',
      style: { fontSize: '0.875rem' }
    },
    {
      fieldName: 'location',
      label: "Location",
      type: 'none',
      style: { fontSize: '0.875rem' }
    }
    , {
      fieldName: 'status',
      label: "Status",
      type: 'status',
      style: { fontSize: '0.875rem' }
    }

  ]

  const customerColumns: IInfoColumns[] = [
    {
      fieldName: 'firstName',
      label: "Name",
      type: 'none',
      style: { fontSize: '0.875rem' }
    },
    {
      fieldName: 'phone',
      label: "Phone",
      type: 'none',
      style: { fontSize: '0.875rem' }
    },
    {
      fieldName: 'zipCode',
      label: "Pin Code",
      type: 'none',
      style: { fontSize: '0.875rem' }
    }
    , {
      fieldName: 'city',
      label: "City",
      type: 'none',
      style: { fontSize: '0.875rem' }
    }

  ]

  const columnsSiteVisit: IInfoColumns[] = [
    {
      fieldName: 'note',
      label: "Note",
      type: 'none',
      style: { fontSize: '0.75rem' }
    },
    {
      fieldName: 'modelName',
      label: "Model Name",
      type: 'none',
      style: { fontSize: '0.75rem' }
    },
    {
      fieldName: 'optionalModel',
      label: "Optional Model",
      type: 'none',
      style: { fontSize: '0.75rem' }
    },

    {
      fieldName: 'images',
      label: "Images",
      type: 'imageList',
      style: { fontSize: '0.75rem' }
    },


  ]
  const choices: any = {
    "isBabyMetal": false,
    "isCement": false,
    "isDust": false,
    "isEarthWork": false,
    "isCrushStone": false,
    "isArtificialGrass": false,
    "isFloorpathi": false,
    "isDrainageSlab": false,
    "isAdditionalLabour": false,
    "isTransportingIssues": false,
  }
  return (
    <>
      <Paper
        elevation={1}
        sx={{
          p: 2,
          borderRadius: 3,
          bgcolor: "#fafafa",
        }}
      >
        <Grid container spacing={2}>
          {/* Surveyor Information */}
          <Grid item xs={12}>
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: "white",
                boxShadow: 1,
              }}
            >
              <Typography sx={{ mb: 1, fontWeight: 600, fontSize: '0.875rem' }}>
                Surveyor Information
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <WSInfocard
                labelStyle={{ fontSize: "0.875rem" }}
                column={columns}
                border={false}
                data={row}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: "white",
                boxShadow: 1,
              }}
            >
              <Typography sx={{ mb: 1, fontWeight: 600, fontSize: '0.875rem' }}>
                Customer Information
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <WSInfocard
                labelStyle={{ fontSize: "0.875rem" }}
                column={customerColumns}
                border={false}
                data={surveyData?.lead}
              />
            </Box>
          </Grid>

          {/* Site Visit Information */}
          {surveyData && (
            <Grid item xs={12}>

              <Box
                sx={{
                  p: 2,
                  borderRadius: 2,
                  bgcolor: "white",
                  boxShadow: 1,
                }}
              >
                <Typography sx={{ mb: 1, fontWeight: 600, fontSize: '0.875rem' }}>
                  Site Visit Information
                </Typography>
                <Divider sx={{ mb: 2 }} />

                {/* <WSInfocard
                  border={false}
                  labelStyle={{ fontSize: "0.875rem" }}
                  column={columnsSiteVisit}
                  data={surveyData}
                /> */}
                <Box>
                  <Grid container spacing={2}>
                    <Grid item sm={2} xs={4}
                      sx={{ borderBottom: "1px solid #eee", pb: 0.5, mb: 1 }}
                    >
                      <Typography sx={{ textTransform: "capitalize", fontSize: '0.75rem' }}>
                        Notes
                      </Typography>
                    </Grid>
                    <Grid item sm={10} xs={8}
                      sx={{ borderBottom: "1px solid #eee", pb: 0.5, mb: 1 }}
                    >
                      <Typography sx={{ textTransform: "capitalize", fontSize: '0.75rem' }}>
                        {surveyData?.note || "-"}
                      </Typography>
                    </Grid>

                    {/* Model Name */}
                    <Grid item sm={2} xs={4}
                      sx={{ borderBottom: "1px solid #eee", pb: 0.5, mb: 1 }}
                    >
                      <Typography sx={{ textTransform: "capitalize", fontSize: '0.75rem' }}>
                        Model Name
                      </Typography>
                    </Grid>
                    <Grid item sm={10} xs={8}
                      sx={{ borderBottom: "1px solid #eee", pb: 0.5, mb: 1 }}
                    >
                      <Typography sx={{ textTransform: "capitalize", fontSize: '0.75rem' }}>
                        {surveyData?.modelName || "-"}
                      </Typography>
                    </Grid>

                    {/* Optional Model */}
                    <Grid item sm={2} xs={4}
                      sx={{ borderBottom: "1px solid #eee", pb: 0.5, mb: 1 }}
                    >
                      <Typography sx={{ textTransform: "capitalize", fontSize: '0.75rem' }}>
                        Optional Model
                      </Typography>
                    </Grid>
                    <Grid item sm={10} xs={8}
                      sx={{ borderBottom: "1px solid #eee", pb: 0.5, mb: 1 }}
                    >
                      <Typography sx={{ textTransform: "capitalize", fontSize: '0.75rem' }}>
                        {surveyData?.optionalModel || "-"}
                      </Typography>
                    </Grid>
                    {Object.keys(choices).map((key) => (
                      <Grid item xs={12} sm={6} key={key}>
                        <Grid
                          container
                          alignItems="center"
                          sx={{ mb: 1, borderBottom: "1px solid #eee", pb: 0.5 }}
                        >
                          <Grid item xs={8}>
                            <Typography sx={{ textTransform: "capitalize", fontSize: '0.75rem' }}>
                              {formatLabel(key)}
                            </Typography>
                          </Grid>
                          <Grid item xs={4}>
                            {surveyData[key] === true ? (
                              <CheckIcon color="success" sx={{ fontSize: '0.75rem' }} />
                            ) : (
                              <CloseIcon color="error" sx={{ fontSize: '0.75rem' }} />
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}
                    <React.Fragment key={'ss'}>

                      <Grid item sm={12} xs={12}>

                        {surveyData?.images && <WSWovenImageList data={surveyData?.images?.split(',') || []} cols={3} width="100%" height={200} />}
                      </Grid>

                    </React.Fragment>
                  </Grid>
                </Box>

              </Box>
            </Grid>
          )}

          {/* Payment Voucher List */}
          <Grid item xs={12}>
            <Box
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: "white",
                boxShadow: 1,
              }}
            >
              <Typography sx={{ mb: 1, fontWeight: 600, fontSize: '0.875rem' }}>
                Payment Voucher List
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <PaymentVoucherList notificationData={row} />
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
});
